<template>
  <div class="dashboard-container">
    <!-- Loader: Top Progress Bar -->
    <div v-if="loading" class="progress-bar" :style="{ width: progress + '%' }"></div>

    <div class="container">
      <!-- Form Title -->
      <div class="mb-2 page-title">
        <i class="bi bi-file-earmark-text"></i>
        {{ isEdit ? "Ubah Klasifikasi Tanding" : "Tambah Klasifikasi Tanding" }}
      </div>

      <!-- Form -->
      <form @submit.prevent="submitForm" class="admin-form mt-4">
        <div class="row">
          <div class="col-lg-12">
            <div class="mb-3">
              <label for="tournament_id" class="form-label">Turnamen</label>
              <select
                class="form-select"
                id="tournament_id"
                v-model="form.tournament_id"
                :class="{ 'is-invalid': errors.tournament_id }"
              >
                <option value="" disabled>Pilih Turnamen</option>
                <option 
                  v-for="tournament in activeTournaments" 
                  :key="tournament.id" 
                  :value="tournament.id"
                >
                  {{ tournament.name }}
                </option>
              </select>
              <div class="invalid-feedback">{{ errors.tournament_id }}</div>
            </div>

            <div class="mb-3">
              <label for="match_category_id" class="form-label">Tingkat (Tanding)</label>
              <select
                class="form-select"
                id="match_category_id"
                v-model="form.match_category_id"
                :class="{ 'is-invalid': errors.match_category_id }"
              >
                <option value="" disabled>{{ form.tournament_id ? 'Pilih Prestasi / Pemasalan' : 'Pilih turnamen dulu' }}</option>
                <option
                  v-for="category in kategoriTanding"
                  :key="category.id"
                  :value="category.id"
                >
                  {{ labelTingkat(category) }}
                </option>
              </select>
              <div class="invalid-feedback">{{ errors.match_category_id }}</div>
              <small v-if="form.tournament_id && !kategoriTanding.length" class="text-muted d-block mt-1">
                Kejuaraan ini belum membuka kategori Tanding. Atur dulu di Jenis &amp; Tarif / Kategori Turnamen.
              </small>
            </div>

            <div class="mb-3">
              <label for="age_category_id" class="form-label">Kelompok Usia</label>
              <select
                class="form-select"
                id="age_category_id"
                v-model="form.age_category_id"
                @change="fetchCategoryClasses"
                :class="{ 'is-invalid': errors.age_category_id }"
              >
                <option value="" disabled>Pilih Kelompok Usia</option>
                <option 
                  v-for="ageCategory in ageCategories" 
                  :key="ageCategory.id" 
                  :value="ageCategory.id"
                >
                  {{ ageCategory.name }}
                </option>
              </select>
              <div class="invalid-feedback">{{ errors.age_category_id }}</div>
            </div>

            <div class="mb-3">
              <label for="name" class="form-label">Nama Klasifikasi</label>
              <input
                type="text"
                class="form-control"
                id="name"
                v-model="form.name"
                :class="{ 'is-invalid': errors.name }"
              />
              <div class="invalid-feedback">{{ errors.name }}</div>
            </div>

          </div>
        </div>

        <div class="row">
          <div class="col-lg-12">
            <div class="table-responsive"><table class="table mt-2">
              <thead>
                <tr>
                  <th colspan="3" class="custom-border">Putra</th>
                  
                </tr>
                <tr>
                  <th class="custom-border text-center">Nama Kelas</th>
                  <th class="custom-border text-center">Berat Min (kg)</th>
                  <th class="custom-border text-center">Berat Maks (kg)</th>
                </tr>
              </thead>
              <tbody>
                <template v-if="maleClasses.length > 0">
                  <tr
                    v-for="maleClass in maleClasses"
                    :key="maleClass.id"
                  >
                    <td class="custom-border px-4 py-2">
                      <div class="form-check">

                        <input 
                            class="form-check-input"
                            type="checkbox" 
                            :id="'male-' + maleClass.id" 
                            v-model="maleClass.selected"
                            :value="maleClass.id"
                        />
                        <label class="form-check-label" :for="'male-' + maleClass.id">{{ maleClass.name }}</label>
                      </div>
                    </td>
                    <td class="custom-border px-4 py-2">{{ maleClass.weight_min }}</td>
                    <td class="custom-border px-4 py-2">{{ maleClass.weight_max }}</td>
                  </tr>
                </template>
                <template v-else>
                  <tr>
                    <td colspan="3" class="text-center">Belum ada kelas untuk kelompok usia ini.</td>
                  </tr>
                </template>
              </tbody>
            </table></div>

            <div class="table-responsive"><table class="table mt-2">
              <thead>
                <tr>
                  <th colspan="3" class="custom-border">Putri</th>
                </tr>
                <tr>
                  <th class="custom-border text-center">Nama Kelas</th>
                  <th class="custom-border text-center">Berat Min (kg)</th>
                  <th class="custom-border text-center">Berat Maks (kg)</th>
                </tr>
              </thead>
              <tbody>
                <template v-if="femaleClasses.length > 0">
                  <tr
                    v-for="femaleClass in femaleClasses"
                    :key="femaleClass.id"
                  >
                    <td class="custom-border px-4 py-2">
                        <div class="form-check">
                          <input 
                                class="form-check-input"
                                type="checkbox" 
                                :id="'male-' + femaleClass.id" 
                                v-model="femaleClass.selected"
                                :value="femaleClass.id"
                            />
                            <label class="form-check-label" :for="'female-' + femaleClass.id"> {{ femaleClass.name }}</label>
                        </div>
                      </td>
                    <td class="custom-border px-4 py-2">{{ femaleClass.weight_min }}</td>
                    <td class="custom-border px-4 py-2">{{ femaleClass.weight_max }}</td>
                  </tr>
                </template>
                <template v-else>
                  <tr>
                    <td colspan="3" class="text-center">Belum ada kelas untuk kelompok usia ini.</td>
                  </tr>
                </template>
              </tbody>
            </table></div>

          </div>
        </div>

        <div class="row">
          <div class="col-lg-12 text-center">
            <button type="submit" class="button button-primary" :disabled="loading">
              <i class="bi bi-floppy"></i>
              <span>{{ isEdit ? "Simpan Perubahan" : "Simpan Klasifikasi" }}</span>
            </button>
          </div>
        </div>
      </form>
    </div>
  </div>
</template>

<script>
import { ratakanGalat } from '@/utils/galatForm';
import axios from "axios";
import { useToast } from "vue-toastification";

export default {
  name: "ClassificationForm",
  props: {
    isEdit: {
      type: Boolean,
      default: false,
    },
  },

  watch: {
    // Pilihan tingkat & usia mengikuti kejuaraan yang dipilih.
    'form.tournament_id'(baru) {
      if (baru) this.muatPilihanKejuaraan();
    },
  },

  computed: {
    /*
     * Klasifikasi hanya untuk TANDING: seni tidak punya kelas berat.
     * Kategori lama yang sedang diubah tetap ditampilkan supaya formulir
     * tidak kosong, meskipun sudah tidak dibuka lagi.
     */
    kategoriTanding() {
      const tanding = this.matchCategories.filter(
        (k) => k.nomor === 'Tanding' || (!k.nomor && Number(k.championship_category_id) === 1)
      );
      const urut = ['Prestasi', 'Pemasalan', 'Khusus'];
      tanding.sort((a, b) => urut.indexOf(a.jenis) - urut.indexOf(b.jenis));
      const kini = this.semuaKategori.find((k) => k.id === this.form.match_category_id);
      if (kini && !tanding.some((k) => k.id === kini.id)) tanding.push(kini);
      return tanding;
    },
    maleClassesData() {
      return this.categoryClasses.filter((item) => item.gender === "male");
    },
    femaleClassesData() {
      return this.categoryClasses.filter((item) => item.gender === "female");
    },
  },

  setup() {
    const toast = useToast();
    return { toast };
  },

  data() {
    return {
      clasificationId: null,
      form: {
        tournament_id: "",
        match_category_id: "",
        age_category_id: "",
        name: "",
        registration_fee: null,
      },
      maleClasses: [], // Move the data here
      femaleClasses: [], // Move the data here
      activeTournaments: [],
      matchCategories: [],
      semuaKategori: [],
      ageCategories: [],
      categoryClasses: [],
      errors: {},
      loading: false,
      progress: 0,
    };
  },
  
  created() {
    this.clasificationId = this.$route.params.id;
    this.fetchActiveTournaments();
    this.fetchData('/match-categories', 'semuaKategori');
    if (this.isEdit && this.clasificationId) {
      this.fetchClasificationDetail(this.clasificationId);
    }
  },

  methods: {
    updateClassificationName() {
      const matchCategory = this.matchCategories.find(
        (category) => category.id === this.form.match_category_id
      );
      const ageCategory = this.ageCategories.find(
        (category) => category.id === this.form.age_category_id
      );

      const matchCategoryName = matchCategory ? matchCategory.name : '';
      const ageCategoryName = ageCategory ? ageCategory.name : '';

      this.form.name = [matchCategoryName, ageCategoryName]
        .filter((name) => name) // Remove empty values
        .join(' - '); // Join with a separator
    },

    async fetchActiveTournaments() {
      await this.fetchData("/tournaments/active", "activeTournaments");
    },
    /** Hanya kategori & kelompok usia yang dibuka di kejuaraan terpilih. */
    async muatPilihanKejuaraan() {
      const params = { tournament_id: this.form.tournament_id };
      try {
        const [k, u] = await Promise.all([
          axios.get('/fetch-match-categories', { params }),
          axios.get('/fetch-age-categories', { params }),
        ]);
        this.matchCategories = k.data || [];
        this.ageCategories = u.data || [];
      } catch (e) {
        this.toast.error('Gagal memuat pilihan kejuaraan.');
      }
    },
    labelTingkat(k) {
      if (k.jenis) return k.nomor === 'Tanding' ? k.jenis : `${k.name} (bukan Tanding)`;
      return k.name;
    },
    async fetchCategoryClasses() {
      if (!this.form.age_category_id) return;

      try {
        const { data } = await axios.get(
          `/category-classes/fetch-by-age-category/${this.form.age_category_id}`
        );

        // If there's no 'selected' in the response, add it here (set default to true)
        this.categoryClasses = data;
        
        // Initialize 'selected' property for maleClasses and femaleClasses
        this.maleClasses = data.male.map(item => ({
          ...item,
          selected: true // Set the default selection to true or false as per your logic
        }));
        
        this.femaleClasses = data.female.map(item => ({
          ...item,
          selected: true // Set the default selection to true or false as per your logic
        }));
      } catch (error) {
        this.toast.error("Gagal memuat daftar kelas.");
      }
    },

    async fetchData(url, targetKey) {
      try {
        const response = await axios.get(url);
        this[targetKey] = response.data;
      } catch (error) {
        this.toast.error("Gagal memuat data pilihan.");
      }
    },

    async fetchClasificationDetail(id) {
      this.loading = true;
      try {
          const response = await axios.get(`/match-clasifications/${id}`, {
              headers: {
                  Authorization: `Bearer ${localStorage.getItem('authToken')}`,
              },
          });

          if (response.data) {
              const data = response.data;

              // Populate form with fetched data
              this.form = {
                  tournament_id: data.tournament_id || null,
                  match_category_id: data.match_category_id || null,
                  age_category_id: data.age_category_id || null,
                  name: data.name || "",
                  /*
                   * ?? bukan ||.
                   * Dengan ||, biaya bernilai 0 (gratis, disengaja) akan
                   * berubah jadi null saat formulir dibuka, dan tersimpan
                   * sebagai "ikut kategori" — diam-diam mengubah tarif yang
                   * sudah ditetapkan panitia.
                   */
                  registration_fee: data.registration_fee ?? null,
              };

              // Ensure details have male and female categories, defaulting to empty arrays
              const maleDetails = data.details.male || [];
              const femaleDetails = data.details.female || [];

              // Loop through all male categories and update based on the 'isSelected' field
              this.maleClasses = maleDetails.map(item => ({
                  ...item,
                  selected: item.isSelected || false,  // Set checkbox as checked/unchecked based on 'isSelected'
              }));

              // Loop through all female categories and update based on the 'isSelected' field
              this.femaleClasses = femaleDetails.map(item => ({
                  ...item,
                  selected: item.isSelected || false,  // Set checkbox as checked/unchecked based on 'isSelected'
              }));

          }
      } catch (error) {
          this.toast.error("Gagal memuat data klasifikasi.");
          console.error("Error:", error);
      } finally {
          this.loading = false;
      }
  },

    async submitForm() {
      this.loading = true;
      try {
        // Combine selected male and female classes into a single array and structure the data as expected by the API
        const selectedClasses = [
          ...this.maleClasses.filter(item => item.selected).map(item => ({ category_class_id: item.id })),
          ...this.femaleClasses.filter(item => item.selected).map(item => ({ category_class_id: item.id }))
        ];

        // Prepare the form data with the details array
        const formData = {
          ...this.form,
          details: selectedClasses,
        };

        // Submit the form data
        const method = this.isEdit ? "put" : "post";
        const endpoint = this.isEdit ? `/match-clasifications/${this.clasificationId}` : "/match-clasifications";

        await axios[method](endpoint, formData);
        
        this.toast.success(`Klasifikasi ${this.isEdit ? "diperbarui" : "ditambahkan"}.`);
        this.$router.push("/admin/match-clasification");
      } catch (error) {
        this.errors = ratakanGalat(error.response?.data?.errors || {});
        this.toast.error(error?.response?.data?.message || "Gagal menyimpan klasifikasi.");
      } finally {
        this.loading = false;
      }
    },
  },
};
</script>

<style scoped>
.progress-bar {
  position: absolute;
  top: 0;
  left: 0;
  height: 5px;
  background: var(--grad-flame);
  animation: loader-animation 1.5s infinite;
}
.invalid-feedback {
  color: #dc3545;
}
@keyframes loader-animation {
  0% {
    width: 0;
    background: var(--grad-flame); /* Warna awal */
  }
  50% {
    width: 50%;
    background: var(--grad-flame); /* Warna saat animasi */
  }
  100% {
    width: 100%;
    background: var(--grad-flame);
  }
}
</style>
